import { Injectable, Pipe, PipeTransform } from '@angular/core';

const MAX_ITEMS_PER_COLUMN = 6;

@Injectable({
  providedIn: 'root',
})
@Pipe({
  name: 'itemsCountToColumnsCount',
})
export class ItemsCountToClassName implements PipeTransform {
  transform(count: number): string {
    return 'columns-' + Math.ceil(count / MAX_ITEMS_PER_COLUMN);
  }
}
